import { Dispatch, SetStateAction, createContext } from "react";

export const HidingContext = createContext<{ hiding: boolean, setHiding: Dispatch<SetStateAction<boolean>> }>({
    hiding: false,
    setHiding: () => false
});

export default HidingContext;